// src/pages/AdminPage.tsx
import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';
import DatabaseCleanup from '../components/form/DatabaseCleanup';

const AdminPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Database Management
                </Typography>
                <DatabaseCleanup />
              </CardContent>
            </Card>
          </Grid>
          
          {/* Add other admin tools here */}
        </Grid>
      </Box>
    </Container>
  );
};

export default AdminPage;